import { twMerge } from 'tailwind-merge';

const INLINE_FIELD_ROW_SHELL =
  'tw:box-border tw:min-h-[2.25rem] tw:inline-flex tw:w-full tw:min-w-0 tw:items-center tw:rounded-lg tw:text-sm tw:leading-5 tw:text-zinc-950 tw:dark:text-white';

/**
 * Display-only shell for inline fields (borderless). Editable controls add their own borders.
 */
export function getInlineFieldSmallShellClasses() {
  return INLINE_FIELD_ROW_SHELL;
}

export function getInlineFieldDefaultShellClasses() {
  return INLINE_FIELD_ROW_SHELL;
}

export function getInlineFieldFocusRingClasses() {
  return 'tw:focus:outline-none tw:focus:ring-2 tw:focus:ring-brand-green-0';
}

export function mergeInlineFieldClassNames(...parts: Array<string | undefined | false>) {
  return twMerge(parts.filter(Boolean) as string[]);
}
